import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * What a row-detail template receives: the expanded row and its index.
 */
export interface EsnTableRowDetailContext<T = unknown> {
  $implicit: T;
  index: number;
}

/**
 * The panel an expandable row opens onto (Figma Table Row State=Full / Empty):
 * `<ng-template esnRowDetail let-row>…</ng-template>`.
 */
@Directive({ selector: 'ng-template[esnRowDetail]' })
// Rows are untyped in templates (`let-row` is `any`), as the directive cannot see the table's row type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class TableRowDetailDirective<T = any> {
  readonly template = inject<TemplateRef<EsnTableRowDetailContext<T>>>(TemplateRef);

  static ngTemplateContextGuard<T>(_dir: TableRowDetailDirective<T>, ctx: unknown): ctx is EsnTableRowDetailContext<T> {
    return true;
  }
}
